import React from 'react';
import "../process.css"

const steps = [
    {
    number: 1,
    title: "Consultation",
    description: "Meet with our team to discuss your vision, budget, and timeline."
    },
    {
    number: 2,
    title: "Design",
    description: "Collaborate on architectural plans and 3D renderings of your dream home."
    },
    {
    number: 3,
    title: "Planning",
    description: "Finalize designs, obtain permits, and prepare for construction."
    },
    {
        number: 4,
        title: "Construction",
        description:"Expert builders bring your home to life with precision and care."
    },
    {
        number: 5,
        title: "Completion",
        description:"Final walkthrough and move-in to your beautifully crafted home."
    }
];

function Process() {
    return (
    <section className="process-container">
        <div className="process-header">
        <h2>Our Process</h2>
        <p>A seamless journey from vision to reality</p>
        </div>

        <div className="timeline">
        {steps.map((step, index) => (
            <div key={index} className="timeline-item">
            <div className="step-number-container">
                <div className="step-number">{step.number}</div>
              {/* This div creates the vertical line between numbers */}
                {index !== steps.length - 1 && <div className="step-line"></div>}
            </div>
            <div className="step-card">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
            </div>
            </div>
        ))}
        </div>
    </section>
    );
};

export default Process;